import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { AutoCompleteModule } from 'primeng/autocomplete'
import { ButtonModule } from 'primeng/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';
import { DatePipe } from '@angular/common';
import { BulletinReportComponent } from './bulletin-report.component';


@NgModule({
    declarations: [BulletinReportComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        RouterModule,
        TableModule,
        DropdownModule,
        InputTextModule,
        AutoCompleteModule,
        ButtonModule,
        InputNumberModule
    ],
    providers: [
        DatePipe,
    ],
})
export class BulletinReportModule {

}